module.exports = __webpack_public_path__ + "img/build1050.5d800799.png";